import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'oms-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './oms-card.component.html',
  styleUrl: './oms-card.component.scss',
})
export class OmsCardComponent {
  @Input() hasBorder: boolean = true;
}
